export default __webpack_public_path__ + "static/media/back-modal.78d243bd.svg";